import RoleService from '@/bundles/Roles/services/RoleService';
import { httpV2 } from '@/bundles/Http/factory/httpFactory';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import RoleToMapper from '@/bundles/Roles/mappers/RoleToMapper';
import McpPermissionMapper from '@/bundles/Roles/mappers/McpPermissionMapper';
import McpRoleMapper from '@/bundles/Roles/mappers/McpRoleMapper';

function roleServiceFactory () {
  return new RoleService({
    transport: httpV2,
    errorMapper: new ErrorMapper(),
    roleMapper: new RoleToMapper(),
    mcpPermissionMapper: new McpPermissionMapper(),
    mcpRoleMapper: new McpRoleMapper(),
  });
}

export const roleService = roleServiceFactory();
